<template>
  <div class="side-panel-right-field bid" v-if="currentMeeting">
    <div class="pa-6 bid__container font font--p-sm">
      <div class="d-flex mb-2 bid__container--details">
        <div class="font--color_light">Дата:</div>
        <div>{{ date }}, {{ time }}</div>
      </div>
      <div class="d-flex mb-2 bid__container--details">
        <div class="font--color_light">Обновлено:</div>
        <div>{{ lastUpdDate }}, {{ lastUpdTime }}</div>
      </div>
      <div class="d-flex mb-2 bid__container--details" v-if="currentMeeting.company_name">
        <div class="font--color_light">Клиент:</div>
        <div>{{ currentMeeting.company_name }}</div>
      </div>
      <div class="d-flex mb-2 bid__container--details" v-if="currentMeeting.inn">
        <div class="font--color_light">ИНН:</div>
        <div>{{ currentMeeting.inn }}</div>
      </div>
      <div v-if="currentMeeting.meeting_state" class="d-flex mb-2 bid__container--details">
        <div class="font--color_light">Статус:</div>
        <div><MeetingStatusChip :value="currentMeeting.meeting_state" /></div>
      </div>
      <div class="d-flex mb-2 bid__container--details">
        <div class="font--color_light">Дата встречи:</div>
        <div>{{ meeting_date }}, {{ meeting_time }}</div>
      </div>
      <div class="d-flex mb-2 bid__container--details" v-if="currentMeeting.meeting_place">
        <div class="font--color_light">Место встречи:</div>
        <div>{{ currentMeeting.meeting_place }}</div>
      </div>
      <div class="d-flex mb-2 bid__container--details" v-if="currentMeeting.place_location">
        <div class="font--color_light">Адрес встречи:</div>
        <div>{{ currentMeeting.place_location }}</div>
      </div>
      <div class="d-flex mb-2 bid__container--details" v-if="meeting_subway">
        <div class="font--color_light">Станция метро:</div>
        <div>{{ meeting_subway }}</div>
      </div>
      <div class="d-flex mb-2 bid__container--details">
        <div class="font--color_light">Телефон клиента:</div>
        <div>{{ formatPhone(currentMeeting.person_phone) }}</div>
      </div>
      <div class="d-flex mb-2 bid__container--details">
        <div class="font--color_light">ФИО:</div>
        <div>{{ currentMeeting.person_fullname }}</div>
      </div>
      <div class="d-flex mb-2 bid__container--details" v-if="currentMeeting.person_email">
        <div class="font--color_light">Электронная почта:</div>
        <div>{{ currentMeeting.person_email }}</div>
      </div>
      <div v-if="currentMeeting.comment" class="d-flex mb-2 bid__container--details">
        <div class="font--color_light">Комментарий:</div>
        <div>{{ currentMeeting.comment }}</div>
      </div>
      <div class="d-flex mb-2 bid__container--details" v-if="currentMeeting.moduldrive_registration_status">
        <div class="font--color_light">Статус регистрации компании в модульдрайв:</div>
        <div class="font-weight-bold">{{ statusText }}</div>
      </div>
      <div class="d-flex mb-2 bid__container--details" v-if="currentMeeting.is_fns_blocked === true">
        <div class="font--color_light">Отложенное открытие:</div>
        <div class="font-weight-bold">Да</div>
      </div>
    </div>

    <!-- Доки для загрузки -->
    <v-container v-if="!waitingForProcess">
      <h4 v-if="files.length > 0" class="font font--color_light mb-2">Документы для встречи:</h4>
      <v-row>
        <v-col cols="12" sm="6" md="4" v-for="file of files" :key="file.id">
          <v-card height="100%">
            <v-card-text>
              <div class="font font--label-light">
                <div class="d-flex justify-center mb-2">
                  <div :class="['fiv-cla', 'fiv-size-lg', getIcon(file.mime)]"></div>
                </div>
                <div class="text-center mb-2">
                  <a :href="file.url" target="_blank">{{ `${file.name}.${file.type}` }}</a>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { formatPhone } from "@/mixins/formatPhone";
import MeetingStatusChip from "@/components/meeting/MeetingStatusChip";

import * as mimeDb from "mime-db";
import icons from "file-icon-vectors/dist/icons/classic/catalog.json";

export default {
  mixins: [formatPhone],
  components: { MeetingStatusChip },
  computed: {
    ...mapState("meeting", ["statuses", "currentMeeting", "currentMeetingId", "registration_status"]),
    ...mapGetters("meeting", ["docs"]),

    status() {
      return this.registration_status[this.currentMeeting.moduldrive_registration_status];
    },
    statusText() {
      return this.registration_status ? this.status?.text : this.currentMeeting.moduldrive_registration_status;
    },
    files() {
      const list = this.docs;
      if (list) {
        return list.map((item) => ({
          // FIXME: бэку нужно отдавать сразу URL
          url: item.id.startsWith("http") ? item.id : `/file/getenc?apid=${this.currentMeetingId}&id=${item.id}`,
          type: item.type,
          name: item.name,
          mime: item.mime,
        }));
      }

      return [];
    },

    date() {
      return this.currentMeeting ? new Date(this.currentMeeting.dadd).toLocaleDateString() : "";
    },
    time() {
      return this.currentMeeting ? new Date(this.currentMeeting.dadd).toLocaleTimeString() : "";
    },
    lastUpdDate() {
      return this.currentMeeting ? new Date(this.currentMeeting.lastUpd).toLocaleDateString() : "";
    },
    lastUpdTime() {
      return this.currentMeeting ? new Date(this.currentMeeting.lastUpd).toLocaleTimeString() : "";
    },
    meeting_date() {
      return this.currentMeeting?.meeting_date ? new Date(this.currentMeeting.meeting_date).toLocaleDateString() : "-";
    },
    meeting_time() {
      return this.currentMeeting?.meeting_date ? new Date(this.currentMeeting.meeting_date).toLocaleTimeString() : "-";
    },
    meeting_subway() {
      return this.currentMeeting?.extra_data?.subway_station;
    },
    waitingForProcess() {
      return this.currentMeeting?.meeting_state === "process";
    },
  },

  methods: {
    getIcon(mimeType) {
      const iconName = mimeDb[mimeType]?.extensions?.find((extension) => icons.includes(extension)) ?? "blank";
      return "fiv-icon-" + iconName;
    },
  },
};
</script>

<style lang="scss" scoped>
.note {
  padding: 14px 20px;
  background: #fcf2ce;
  border-radius: 3px;
  margin-bottom: 16px;
  .font--color_warning {
    color: #d2aa0f;
  }
}
.bid {
  @media (max-width: 500px) {
    padding: 0;
  }

  &__container {
    background-color: #f5f5f6;
    & > div > div:first-child {
      @media (min-width: 501px) {
        flex-basis: 230px;
        min-width: 230px;
      }
    }
    & > div > div:last-child {
      word-wrap: break-word;
      word-break: break-word;
    }
  }
  &__container--details {
    @media (max-width: 500px) {
      flex-direction: column;
      flex-basis: 0px;
      min-width: 0px;
    }
  }
}
</style>
